module.exports = __webpack_public_path__ + "img/td.e092133d.svg";